<div class="surface-ground min-h-screen p-4">
  <share-page-header title="CRM" subtitle="Manage and work leads"> </share-page-header>

  <share-module-tabs
    [tabs]="tabs"
    [activeKey]="activeTabKey"
    (tabChange)="onTabChange($event)"
  ></share-module-tabs>

  <div [ngSwitch]="activeTabKey">
    <!-- Active Leads -->
    <ng-container *ngSwitchCase="'active-leads'">
      <share-section-card title="Filter Leads" icon="pi pi-filter" class="mb-0">
        <div class="flex align-items-center flex-wrap gap-3">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="filterValue"
              (ngModelChange)="filterLeads()"
              placeholder="Search by company name"
            />
          </span>
          <p-checkbox
            label="Show only leads with upcoming interactions"
            [binary]="true"
            [(ngModel)]="showOnlyWithInteraction"
            (onChange)="filterLeadsOnlyNextInteraction()"
          ></p-checkbox>
        </div>
      </share-section-card>

      <div class="grid">
        <!-- Lead Detail -->
        <div class="col-12 lg:col-4">
          <share-section-card title="Lead Detail" icon="pi pi-user" shadow="shadow-1">
            <p-progressBar
              *ngIf="leadsService.isLeadsActiveLoading$.getValue()"
              mode="indeterminate"
              styleClass="mb-3"
            ></p-progressBar>
            <app-lead-detail
              [lead]="activeLead"
              [loading]="leadsService.isLeadsActiveLoading$.getValue()"
            ></app-lead-detail>
            <p-divider></p-divider>
            <button
              *appHasPermission="'lead_actions.create'"
              pButton
              type="button"
              label="Add Action"
              icon="pi pi-plus"
              class="p-button-primary w-full mb-3"
              (click)="showAddAction($event)"
            ></button>
            <div class="flex gap-2 flex-wrap">
              <button
                pButton
                pRipple
                label="First"
                class="p-button-outlined p-button-sm flex-1"
                icon="pi pi-angle-double-left"
                iconPos="left"
                (click)="firstLead()"
                [disabled]="!(activeIndex >= 1)"
              ></button>
              <button
                pButton
                pRipple
                label="Prev"
                class="p-button-outlined p-button-sm flex-1"
                icon="pi pi-angle-left"
                iconPos="left"
                (click)="previousLead()"
                [disabled]="!(activeIndex >= 1)"
              ></button>
              <button
                pButton
                pRipple
                [label]="activeIndex + 1 + ' / ' + leads.length"
                class="p-button-text p-button-sm flex-1"
                [disabled]="true"
              ></button>
              <button
                pButton
                pRipple
                label="Next"
                class="p-button-outlined p-button-sm flex-1"
                icon="pi pi-angle-right"
                iconPos="right"
                (click)="nextLead()"
                [disabled]="!(activeIndex < leads.length - 1)"
              ></button>
              <button
                pButton
                pRipple
                label="Last"
                class="p-button-outlined p-button-sm flex-1"
                icon="pi pi-angle-double-right"
                iconPos="right"
                (click)="lastLead()"
                [disabled]="!(activeIndex < leads.length - 1)"
              ></button>
            </div>
          </share-section-card>
        </div>

        <!-- Script -->
        <div class="col-12 lg:col-4">
          <share-section-card title="Script" icon="pi pi-file-o" shadow="shadow-1">
            <app-lead-script></app-lead-script>
          </share-section-card>
        </div>

        <!-- Timeline -->
        <div class="col-12 lg:col-4">
          <share-section-card title="Timeline" icon="pi pi-history" shadow="shadow-1">
            <p-progressBar
              *ngIf="leadsService.isLeadsActiveLoading$.getValue()"
              mode="indeterminate"
              styleClass="mb-3"
            ></p-progressBar>
            <app-lead-timeline [lead]="activeLead"></app-lead-timeline>
          </share-section-card>
        </div>
      </div>
    </ng-container>

    <!-- Parked Leads -->
    <ng-container *ngSwitchCase="'parked-leads'">
      <div *ngIf="!activeLeadPersonal" class="text-center p-4 mb-4">
        <share-empty-state
          icon="pi pi-pause-circle"
          heading="No parked leads"
          message="You have no qualified or parked leads at the moment."
        ></share-empty-state>
      </div>

      <ng-container *ngIf="activeLeadPersonal">
        <share-section-card title="Filter Leads" icon="pi pi-filter" class="mb-0">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="filterPersonalValue"
              (ngModelChange)="filterPersonalLeads()"
              placeholder="Search by company name"
            />
          </span>
        </share-section-card>

        <div class="grid">
          <div class="col-12 lg:col-6">
            <share-section-card title="Lead Detail" icon="pi pi-user" shadow="shadow-1">
              <app-lead-detail
                [lead]="activeLeadPersonal"
                [loading]="leadsService.isLeadsPersonalLoading$.getValue()"
              ></app-lead-detail>
              <p-divider></p-divider>
              <button
                *appHasPermission="'lead_actions.create'"
                pButton
                type="button"
                label="Add Action"
                icon="pi pi-plus"
                class="p-button-primary w-full mb-3"
                (click)="showAddActionPersonal($event)"
              ></button>
              <div class="flex gap-2">
                <button
                  pButton
                  pRipple
                  label="Previous"
                  class="p-button-outlined p-button-sm flex-1"
                  icon="pi pi-arrow-left"
                  iconPos="left"
                  (click)="previousLeadPersonal()"
                  [disabled]="!(activePersonalIndex >= 1)"
                ></button>
                <button
                  pButton
                  pRipple
                  [label]="activePersonalIndex + 1 + ' / ' + leadsPersonal.length"
                  class="p-button-text p-button-sm flex-1"
                  [disabled]="true"
                ></button>
                <button
                  pButton
                  pRipple
                  label="Next"
                  class="p-button-outlined p-button-sm flex-1"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  (click)="nextLeadPersonal()"
                  [disabled]="!(activePersonalIndex < leadsPersonal.length - 1)"
                ></button>
              </div>
            </share-section-card>
          </div>
          <div class="col-12 lg:col-6">
            <share-section-card title="Timeline" icon="pi pi-history" shadow="shadow-1">
              <app-lead-timeline [lead]="activeLeadPersonal"></app-lead-timeline>
            </share-section-card>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
